<template>
  <div>
    <v-container fluid>
      <v-layout
        align-center
        justify-center
      >
        <v-flex
          xs12
          sm8
          md6
          class="mt-4"
        >
          <keep-alive>
            <component v-bind:is="displayedComponent"></component>
          </keep-alive>
        </v-flex>
      </v-layout>
    </v-container>
    <v-bottom-nav
      :value="showConnectionPane"
      :active.sync="bottomNav"
      fixed
      dark
      app
    >
      <v-btn value="connectionState">
        <span>{{connectionStateName}}</span>
        <v-icon :color="connectionStateIconColor">{{connectionStateIcon}}</v-icon>
      </v-btn>
    </v-bottom-nav>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import GameModel from "../../api/game-model";
import TeamRegistration from "../../components/GameClient/TeamRegistration";
import ConnectedClient from "../../components/GameClient/ConnectedClient";

export default {
  name: "GameClient",
  props: ["code"],
  data() {
    return {
      connectionStates: GameModel.ConnectionState,
      displayedComponent: "",
      connectionStateIcon: "",
      connectionStateIconColor: "",
      connectionStateName: "",
      showConnectionPane: false,
      bottomNav: "connectionState"
    };
  },
  methods: {
    ...mapActions("client", ["connectWebSocket", "validateGameCode"]),
    ...mapMutations("client", ["updateConnectionState"])
  },
  computed: {
    ...mapState("client", {
      connectionState: state => state.connectionState,
      apiMessage: state => state.apiMessage
    }),
    ...mapGetters("client", {
      token: "token"
    }),
    invalidCode() {
      return this.connectionState === this.connectionStates.INVALID_CODE;
    }
  },
  watch: {
    async connectionState(newState, oldState) {
      if (
        this.connectionState === this.connectionStates.VALID_CODE ||
        this.connectionState === this.connectionStates.INVALID_TEAM
      ) {
        this.displayedComponent = "TeamRegistration";
      }
      if (this.connectionState === this.connectionStates.VALID_TEAM) {
        this.connectWebSocket().catch(e => alert("Bummer, the web socket connection to our server failed... " + e.message));
      }
      if (this.connectionState === this.connectionStates.CONNECTED) {
        this.displayedComponent = "ConnectedClient";
        this.connectionStateIcon = "cloud_done";
        this.connectionStateIconColor = "green";
        this.connectionStateName = "Connected";
        this.showConnectionPane = true;
      }
      if (this.connectionState === this.connectionStates.DISCONNECTED) {
        this.connectionStateIcon = "cloud_off";
        this.connectionStateIconColor = "red";
        this.connectionStateName = "Disconnected, retrying...";
      }
    },
    invalidCode(codeInValid) {
      if (codeInValid) {
        this.$router.push({
          name: "Home",
          query: {
            code: this.code,
            apiMessage: this.apiMessage
          }
        });
      }
    }
  },
  created() {
    if (this.token !== "") {
      // Refresh of the page or maybe back button. Either way, if we have the token stored no need to register team again
      this.updateConnectionState(GameModel.ConnectionState.VALID_TEAM);
    } else {
      this.validateGameCode(this.code).catch(e =>
        alert("Bummer, we failed to validate your game code... " + e.message)
      );
    }
  },
  components: {
    TeamRegistration,
    ConnectedClient
  }
};
</script>